export default "__VITE_ASSET__BcxEql11__"